__turbopack_context__.v({
  "avatar": "HeaderProfile-module__W5iMDa__avatar",
  "editProfile": "HeaderProfile-module__W5iMDa__editProfile",
  "editProfileButton": "HeaderProfile-module__W5iMDa__editProfileButton",
  "editProfileIcon": "HeaderProfile-module__W5iMDa__editProfileIcon",
  "editProfileText": "HeaderProfile-module__W5iMDa__editProfileText",
  "headerWrapper": "HeaderProfile-module__W5iMDa__headerWrapper",
  "links": "HeaderProfile-module__W5iMDa__links",
  "membershipLink": "HeaderProfile-module__W5iMDa__membershipLink",
  "textContent": "HeaderProfile-module__W5iMDa__textContent",
});
